import { HTMLAttributes, ReactNode } from 'react';
import clsx from 'clsx';
import Icon from 'components/UI/Icons/Icon';
import styles from './styles.module.scss';

export type TBannerVariant = 'warning' | 'error' | 'info';

export interface IBannerProps extends HTMLAttributes<HTMLDivElement> {
  variant: TBannerVariant;
  children: ReactNode;
  onClose?: () => void;
}

export const Banner = ({
  variant,
  children,
  onClose,
  className,
  ...rest
}: IBannerProps) => (
  <div className={clsx(styles.banner, styles[variant], className)} {...rest}>
    <Icon iconType="circleInfoFilled" />
    <div className={styles.content}>{children}</div>
    {onClose && (
      <button
        type="button"
        className={styles.closeButton}
        onClick={onClose}
        aria-label="Close"
      >
        ×
      </button>
    )}
  </div>
);
